import { render } from "./superset_manager.html?vue&type=template&id=4f3c7063&external"
import script from "./superset_manager.js?vue&type=script&lang=js&external"
export * from "./superset_manager.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__